var nb = {
    noMatch: 'Ingen samsvarende konto',
};
var nn = {
    noMatch: 'Ingen samsvarande konto',
};
var en = {
    noMatch: 'No matching account',
};
export var texts = { nb: nb, nn: nn, en: en };
